import React, { useEffect } from "react";
import { withRouter } from "./with-router";

const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};

// a component that checks the expiration of the jwt on every location change
// if the jwt has expired, logs out the user automatically
const AuthVerify = (props) => {
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      const decodedJwt = parseJwt(user.jwt_token);

      if (decodedJwt.exp * 1000 < Date.now()) {
        console.log("logging out user because JWT has expired");
        props.logOut();
      } else {
        console.log("were good");
      }
    }
  }, [props]);

  return <div></div>;
};

export default withRouter(AuthVerify);
